import './index.scss';
import { observer } from 'mobx-react-lite';
import XImg from '@assets/svg/x.svg';
import { Context } from '@/index';
import { useContext, useState, useRef, useEffect } from 'react';
import { AttachFilesAndLinks } from '@Components/AttachFilesAndLinks';
import { createPortfolio as createPortfolioApi, uploadPortfolioFiles as uploadPortfolioFilesApi, uploadPortfolioUrls as uploadPortfolioUrlsApi } from '@api/user-api';
// ----------------
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// ----------------
import { toast } from 'react-toastify';
import { toastOptions } from '@shared/index';

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required('İşin adını daxil edin')
        .min(2, 'Ad ən azı 2 simvoldan ibarət olmalıdır')
        .max(60, 'Ad ən çox 60 simvoldan ibarət olmalıdır'),
    description: Yup.string()
        .required('Təsviri daxil edin')
        .min(16, 'Təsvir ən azı 16 simvoldan ibarət olmalıdır')             
        .max(1200, 'Təsvir ən çox 1200 simvoldan ibarət olmalıdır'),               
})
const formOptions = { resolver: yupResolver(validationSchema), shouldUnregister: true }

const AddProjectsModal = observer(({ callback }) => {
    const { modal } = useContext(Context);
    const { register, watch, handleSubmit, formState: { errors } } = useForm(formOptions);
    const [ nameCharacters,  setNameCharacters ] = useState(0);
    const [ descriptionCharacters,  setDescriptionCharacters ] = useState(0);
    const [ isDisabled, setIsDisabled] = useState(false);

    const selectedFilesRef = useRef([]);
    const selectedLinksRef = useRef([]);
    const [ isUploading, setIsUploading ] = useState(false);
    const buttonSpinner = useRef(null);

    useEffect(() => {
        if(isUploading) {
            setIsDisabled(true);
            buttonSpinner.current.style.display = "inline-block";
        } else {
            setIsDisabled(false);
            buttonSpinner.current.style.display = "none";
        }
    }, [isUploading]);

    const onFilesOrLinksChange = (files, links, isSizeLimit) => {
        selectedFilesRef.current = files;
        selectedLinksRef.current = links;
        setIsDisabled(isSizeLimit);
    }

    useEffect(() => {
        const subscription = watch((value) => {
            let { name, description } = value;
            if (name || description) {
                setNameCharacters(name.length);
                setDescriptionCharacters(description.length);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (obj) => {
        setIsUploading(true);
        createPortfolioApi(obj)
        .then( async (res) => {
            const [
                uploadPortfolioUrlsResult,
                uploadPortfolioFilesResult
            ] = await Promise.allSettled([
                (res && res.data && selectedLinksRef.current.length) ? uploadPortfolioUrlsApi({portfolio: res.data.id, url: selectedLinksRef.current}) : Promise.resolve(),
                (res && res.data && selectedFilesRef.current.length) ? uploadPortfolioFilesApi(res.data.id, selectedFilesRef.current) : Promise.resolve(),
            ]);
            if (uploadPortfolioUrlsResult.status === 'fulfilled' && uploadPortfolioUrlsResult.status === 'fulfilled') {
                toast.success('Layihə portfolyoda saxlanıldı', toastOptions);
            } else {
                toast.error('Layihə portfolyoda xətalar ilə saxlanıldı', toastOptions);
            }
            if (uploadPortfolioUrlsResult.status === 'rejected') {
                toast.error('Layihəyə link əlavə edilməsində xəta baş verdi', toastOptions);
            }
            if (uploadPortfolioFilesResult.status === 'rejected') {
                toast.error('Layihəyə fayllar əlavə edilməsində xəta baş verdi', toastOptions);
            }
            setIsUploading(false);
            callback();
            modal.closeModal();
        })
        .catch(() => {
            setIsUploading(false);
            callback();
            toast.error('Layihənin Portfolyoya əlavə edilməsində xəta baş verdi', toastOptions);
            modal.closeModal();
        });
    }

    return (
        <div className="add-projects-modal">
            <div className="header-modal">
Portfolyoya iş əlavə et
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x"/>
                </div>
            </div>
            <form className="form" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-control-block">
                    <label htmlFor="name" className="form-label">
İşin adı
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="name" 
                        placeholder=""
                        {...register("name")}
                    />
                    <div className="tip">
                        {`${nameCharacters}/60`}
                    </div>
                    {errors.name?.message && (
                        <p className="error">{errors.name?.message}</p>
                    )}
                </div>
                <div className="form-control-block">
                    <label htmlFor="description" className="form-label">
Təsvir
                    </label>
                    <textarea
                        className="form-control"
                        id="description"
                        rows="2" 
                        placeholder="" 
                        {...register("description")}
                    >
                    </textarea>
                    <div className="tip">
                        {`${descriptionCharacters}/1200`}
                    </div>
                    {errors.description?.message && (
                        <p className="error">{errors.description?.message}</p>
                    )}
                </div>
                <AttachFilesAndLinks
                    onChangeCallback={onFilesOrLinksChange}
                    label="Əlavə materiallar üçün fayllar və ya linklər əlavə edin"
                />
                <div className="actions">
                    <button type='button' className="cancel" onClick={() => modal.closeModal()}>
Ləğv et
                    </button>
                    <button type="submit" className="my-button first-button" disabled={isDisabled}>
                        <span ref={buttonSpinner} className="button-custom-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
Saxla
                    </button>
                </div>
            </form>
        </div>
    )
})

export { AddProjectsModal }